import React, { useEffect, useRef } from 'react';
import styles from './App.module.scss';
import { Outlet, useLoaderData, useLocation } from 'react-router-dom';
import { AppConfig, Topic } from '../Models';
import { getAppConfigData } from '../Services/AppService';
import { TopBar } from '../Components/TopBar/TopBar';
import { Footer } from 'footer-component';
import { addGAScript } from '../Services/AnalyticsService';

export const loader = async (): Promise<AppConfig> => {
  const data: AppConfig = await getAppConfigData();
  document.title = data.header.title;
  addGAScript(data.ga_id);
  return Promise.resolve(data);
};

function App() {
  const config = useLoaderData() as AppConfig;
  const location = useLocation();
  const refContent = useRef<HTMLDivElement>(null);

  // Scroll to top when route changes
  useEffect(() => {
    refContent.current && refContent.current.scrollTo(0, 0);
  }, [location]);

  const activeTopics: Topic[] = config.body.topics.filter(
    (topic: Topic) => topic.active
  );

  return (
    <div className={styles.app}>
      <TopBar
        icon={config.header.icon}
        links={config.header.links}
        topics={activeTopics}
      />

      <div ref={refContent} className={styles.content}>
        <main className={styles.outlet}>
          <Outlet context={config} />
        </main>

        <Footer url={process.env.REACT_APP_FOOTER_URL as string} />
      </div>
    </div>
  );
}

export default App;
